import axios from "@/api/http"; // 导入http中创建的axios实例
import base from "@/api/base";
import doctor from "./user"; // 导入接口域名列表

const label = {

  queryLabelPage() {
    return axios.get(
      `${base.baseURL_clinic}/label/get`);
  },

  deleteLabel(data) {
    return axios.post(
      `${base.baseURL_clinic}/label/delete?id=${data.id}`,);
  },
  editLabel(data) {
    return axios.post(
      `${base.baseURL_clinic}/label/update`,data
    )
  },
  addLabel(data) {
    return axios.post(
      `${base.baseURL_clinic}/label/addOne`,data
    )
  },
  queryServiceTagPage() {
    return axios.get(
      `${base.baseURL_clinic}/serviceTag/get`);
  },
  deleteServiceTag(data) {
    return axios.post(
      `${base.baseURL_clinic}/serviceTag/delete?id=${data.id}`,);
  },
  editServiceTag(data) {
    return axios.post(
      `${base.baseURL_clinic}/serviceTag/update`,data
    )
  },
  addServiceTag(data) {
    return axios.post(
      `${base.baseURL_clinic}/serviceTag/add`,data
    )
  },
}
export default label;



// WEBPACK FOOTER //
// ./src/network/label.js